export default __webpack_public_path__ + "static/media/news171.aa30df74.jpg";